import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, output, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { InlineGroupComponent } from '@structural/inline-group/inline-group.component';
import { BaseModalComponent } from '../base-modal/base-modal.component';
import { ModalLayoutComponent } from '../base-modal/modal-layout/modal-layout.component';
import type { ModalContent } from './confirm-modal.type';

export type confirmModalResponse = { confirm: boolean; message: string };

@Component({
  selector: 'woo-confirm-modal',
  imports: [ModalLayoutComponent, InlineGroupComponent, FormsModule, CommonModule],
  templateUrl: './confirm-modal.component.html',
  styleUrl: './confirm-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmModalComponent extends BaseModalComponent<ModalContent> {
  content = this.modaldata;
  consent = signal<boolean>(false);
  output = output<confirmModalResponse>();

  submit(): void {
    this.output.emit({ confirm: true, message: this.content().comment?.text ? this.content().comment.text : '' });
    this.close();
  }

  abort(): void {
    this.output.emit({ confirm: false, message: this.content().comment?.text ? this.content().comment.text : '' });
    this.close();
  }
}
